import { Controller } from "stimulus";
import EnrollmentChannel from '../entrypoints/src/admin/channels/enrollment_channel';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import CreditCardFormValidation from '../entrypoints/src/admin/components/credit_card_form_validation';

export default class extends Controller {
  connect() {
    this.$btnContinue = this.element.querySelector('.btn#continue');
    this.$spVendorName = this.element.querySelector('.credit-card-vendor-name');
    this.formValidation = this.initCreditCardFormValidation();

    this.enrollmentChannel = EnrollmentChannel.create(this.element.dataset.enrollmentId, {
      connected() {
        this.credit_card('credit-card/opened');
      }
    });

    console.log('this.enrollmentChannel', this.enrollmentChannel);
    this.bindEvents();
  }

  initCreditCardFormValidation() {
    let _this = this;

    return new CreditCardFormValidation(this.element, {
      afterValidate(valid) {
        _this.$btnContinue.classList.toggle('disabled', !valid);
      },

      onCardNumberChange(creditCard) {
        _this.element.querySelectorAll(`[data-card-brand]`).forEach((el) => {
          el.classList.toggle('hidden', true);
          el.classList.replace('valid', 'invalid');
        });
        _this.$spVendorName.innerHTML = 'Desconhecido';

        if (!creditCard.card)
          return true;

        _this.$spVendorName.innerHTML = creditCard.card.niceType;
        let brand = _this.element.querySelector(`[data-card-brand="${creditCard.card.type.replace(/[-]/, '')}"]`);

        if (!brand)
          return true;

        brand.classList.toggle('hidden', false);

        if (!creditCard.isValid)
          return;

        brand.classList.replace('invalid', 'valid');
      }
    });
  }

  bindEvents() {
    this.$btnContinue.addEventListener('click', (ev) => {
      ev.preventDefault();

      if (this.$btnContinue.classList.contains('disabled'))
        return;

      AjaxLoader.show();
      this.enrollmentChannel.credit_card('credit-card/submitted');
      this.$btnContinue.closest('form').submit();
    });
  }
}